import React from "react";
import styles from "./StatsBar.module.css";

const stats = [
  { value: "50+", label: "Projects Completed" },
  { value: "8+",   label: "Years of Excellence" },
  { value: "98%",  label: "Client Satisfaction" },
  { value: "3",    label: "Cities Served" },
];

const StatsBar = () => {
  return (
    <section className={styles.section}>
      {stats.map((stat, i) => (
        <div key={i} className={styles.statItem}>
          <span className={styles.value}>{stat.value}</span>
          <span className={styles.label}>{stat.label}</span>
          {i < stats.length - 1 && <div className={styles.divider} />}
        </div>
      ))}
    </section>
  );
};

export default StatsBar;
